import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

/** يفتح نافذة تغيير كلمة المرور من صفحة الملف الشخصي */
function UpdatePassword() {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/profile', { replace: true, state: { openPassword: true } });
    }, [navigate]);

    return (
        <Box className="flex justify-center py-20">
            <CircularProgress size={40} />
        </Box>
    );
}

export default UpdatePassword;
